import { RouterType } from '@/types/router'
import { getLocalItem } from '@/utils/localStorage'

const footerRoute: RouterType[] = [
  {
    title: '底部页面',
    name: 'footerWebs',
    path: '/footerWebs',
    authenticating: true,
    component: () =>
      getLocalItem('zl-user-token') ? import('@/views/layout/index.vue') : import('@/views/footerWebs/frame.vue'),
    children: [
      {
        path: 'CertificateOfQualification',
        component: () => import('@/views/footerWebs/certificateOfQualification.vue'),
        name: 'CertificateOfQualification',
        meta: { title: '资质证明' }
      },
      {
        path: 'QualificationOfPersonnel',
        component: () => import('@/views/footerWebs/qualificationOfPersonnel.vue'),
        name: 'QualificationOfPersonnel',
        meta: { title: '人员资质' }
      },
      {
        path: 'LawsRegulations',
        component: () => import('@/views/footerWebs/lawsRegulations.vue'),
        name: 'LawsRegulations',
        meta: { title: '法律法规' }
      },
      {
        path: 'SafetyGuidelines',
        component: () => import('@/views/footerWebs/safetyGuidelines.vue'),
        name: 'SafetyGuidelines',
        meta: { title: '安全指引' }
      },
      {
        path: 'OpenList',
        component: () => import('@/views/footerWebs/openList.vue'),
        name: 'OpenList',
        meta: { title: '开户清单' }
      }
    ]
  }
]

export { footerRoute }
